import { Notification, NotificationType } from '../collections/notification/notification.interface';
import store from '../store';

const usestore = store;

export function notifyInfo(notification: Notification) {
   usestore.commit('notification/ADD_NOTIFICATION', {
      ...notification,
      type: NotificationType.Info,
      timeout: notification.timeout || 5000,
   } as Notification);
}

export function notifySuccess(notification: Notification) {
   const dateKey = new Date().getMilliseconds();
   usestore.commit('notification/ADD_NOTIFICATION', {
      ...notification,
      key: dateKey + `${Math.random()}`,
      type: NotificationType.Success,
      timeout: notification.timeout || 5000,
   } as Notification);
}

export function notifyWarning(notification: Notification) {
   usestore.commit('notification/ADD_NOTIFICATION', {
      ...notification,
      type: NotificationType.Warning,
      timeout: notification.timeout || 5000,
   } as Notification);
}

export function notifyError(notification: Notification) {
   usestore.commit('notification/ADD_NOTIFICATION', {
      ...notification,
      type: NotificationType.Danger,
      timeout: notification.timeout || 5000,
   } as Notification);
}
